import { useEffect, useState } from "react";
import { api, unwrap } from "@/lib/api";

export function useStats({ branchId, intervalMs = 5000 } = {}) {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    const fetchOnce = async () => {
      try {
        const params = branchId ? { branch_id: branchId } : {};
        const r = await api.get("/stats/today", { params });
        if (active) setStats(unwrap(r));
      } catch {}
      finally { if (active) setLoading(false); }
    };
    fetchOnce();
    const id = setInterval(fetchOnce, intervalMs);
    return () => { active = false; clearInterval(id); };
  }, [branchId, intervalMs]);

  return { stats, loading };
}
